var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box, TextField, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
var InfoField = function (_a) {
    var label = _a.label, value = _a.value, editable = _a.editable, _b = _a.icon, Icon = _b === void 0 ? AccountBalanceIcon : _b;
    var _c = useState(false), isEditing = _c[0], setIsEditing = _c[1];
    var _d = useState(value), textValue = _d[0], setTextValue = _d[1];
    useEffect(function () {
        setTextValue(value);
    }, [value]);
    var handleEditClick = function () { return setIsEditing(true); };
    var handleChange = function (e) { return setTextValue(e.target.value); };
    var handleSaveClick = function () { return setIsEditing(false); };
    return (_jsxs(Box, __assign({ width: "100%" }, { children: [_jsxs(Box, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }, { children: [_jsxs(Box, __assign({ display: "flex", alignItems: "center", gap: 1 }, { children: [_jsx(Icon, { fontSize: "small", color: "primary" }), _jsx(Typography, __assign({ variant: "body2", fontWeight: 600 }, { children: label }))] })), editable && (!isEditing ? (_jsxs(IconButton, __assign({ onClick: handleEditClick, size: "small" }, { children: [_jsx(EditIcon, { fontSize: "small" }), _jsx(Typography, __assign({ variant: "body2", ml: 0.5 }, { children: "Editar" }))] }))) : (_jsxs(IconButton, __assign({ onClick: handleSaveClick, size: "small" }, { children: [_jsx(SaveIcon, { fontSize: "small" }), _jsx(Typography, __assign({ variant: "body2", ml: 0.5 }, { children: "Guardar" }))] }))))] })), _jsx(TextField, { fullWidth: true, variant: "outlined", size: "small", value: textValue, onChange: handleChange, disabled: !isEditing, InputProps: { style: { backgroundColor: isEditing ? '#fff' : '#f9f9f9' } } })] })));
};
export default InfoField;
